import React, { useState, useEffect } from 'react'
import { Table, Button, Modal, Input, Space, Select, Switch } from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import axios from 'axios'

import {
  UpdateClassMaster,
  CreateClassMaster,
  GetClassMaster,
  UpdateClassStatus,
  GeJobCategorysMaster,
  UpdateJobCategoryMaster,
  CreateJobCategoryMaster,
  GetJobCategorysMaster,
} from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'

const CategoryMaster = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // --- FORM STATES USING useState ---
  const [categoryName, setCategoryName] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingId, setEditingId] = useState(null)

  useEffect(() => {
    fetchCategory()
  }, [])

  const fetchCategory = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${GetJobCategorysMaster}`)

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        category_name: item.category_name,
        branch_id: item.branch_id,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load category')
    } finally {
      setLoading(false)
    }
  }

  // --- OPEN MODAL ---
  const handleOpenModal = (record = null) => {
    if (record) {
      setEditingId(record.key)
      setCategoryName(record.category_name)
    } else {
      setEditingId(null)
      setCategoryName('')
    }
    setIsModalOpen(true)
  }

  // --- SAVE OR UPDATE ---
  const handleSave = async () => {
    if (!categoryName.trim()) return toast.error('Please enter category name')

    const payload = {
      branch_id: storedBranchId,
      category_name: categoryName,
    }

    try {
      if (editingId) {
        const res = await axios.put(
          `${UpdateJobCategoryMaster}/${editingId}`,
          payload,
        )
        if (res.data === 'UPDATED') {
          toast.success('Category updated successfully')
        }
      } else {
        const res = await axios.post(CreateJobCategoryMaster, payload)
        if (res.data === 'SAVED') {
          toast.success('Category added successfully')
        }
      }

      fetchCategory()
      setIsModalOpen(false)
      setEditingId(null)
      setCategoryName('')
    } catch (err) {
      toast.error('Failed to save category')
    }
  }


  // --- SEARCH ---
  const filteredData = data.filter((item) =>
    ((item.category_name ?? '') + '')
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  )

  const columns = [
    { title: 'Sr No', dataIndex: 'index' },
    { title: 'Category', dataIndex: 'category_name' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Job Category Master</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search Category..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />

            <Button
              className="addButton mt-2 mt-md-0"
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal()}
              style={{ marginLeft: 10 }}
            >
              Add Category
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      <Modal
        title={editingId ? 'Edit Category' : 'Add Category'}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="save"
            className="addButton"
            type="primary"
            onClick={handleSave}
          >
            Save
          </Button>,
        ]}
      >
        <div className="mb-3">
          <label>Category Name</label>
          <Input
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter category name"
          />
        </div>

      </Modal>
    </div>
  )
}

export default CategoryMaster
